import ExitModal from "../components/ExitModal.svelte"
const ExitModalTarget = document.getElementById("exitModalComponent")

ExitModalTarget &&
  new ExitModal({
    target: ExitModalTarget,
    props: {
      siteKey: ExitModalTarget.dataset["siteKey"],
      authToken: ExitModalTarget.dataset["authToken"],
      honeypot: ExitModalTarget.dataset["hp"],
    },
  })
